exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1APIZ{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}._3JEMv{color:-wix-colors-buttonsAndLinksColor}[data-layout=\"2\"] ._3JEMv{color:-wix-colors-mobileButtonsBackgroundColor}._3PwC9 ._3213x{display:inline-block;width:70px;height:50px}._3PwC9 ._3jSmP{height:48px;padding:0 15px}._3PwC9 ._1mzT3{position:relative}._3PwC9 ._1mzT3 ._3Wb9J,.FZYko{display:-ms-flexbox;display:flex}.FZYko{position:relative}[data-view-mode=editor] .FZYko{background-color:-wix-colors-emptyPlayerBgEditor}[data-view-mode=preview] .FZYko,[data-view-mode=site] .FZYko{background-color:-wix-colors-emptyPlayerBgSite}._2HF-G{-ms-flex-negative:0;flex-shrink:0;position:relative}._1Q_n7{position:relative;background-color:#000}._3NHML{position:absolute;left:0;right:0;z-index:0}._2OSHo{position:absolute;left:0;right:0;z-index:10}.RIVkR{position:relative}", ""]);

// exports
exports.locals = {
	"spinner-container": "_1APIZ",
	"spinnerContainer": "_1APIZ",
	"spinner": "_3JEMv",
	"container": "_3PwC9",
	"box": "_3213x",
	"header": "_3jSmP",
	"player-wrapper": "_1mzT3",
	"playerWrapper": "_1mzT3",
	"player": "_3Wb9J",
	"overlay-only": "FZYko",
	"overlayOnly": "FZYko",
	"overlay-item-topmost": "_2HF-G",
	"overlayItemTopmost": "_2HF-G",
	"new-mobile-ui-container": "_1Q_n7",
	"newMobileUiContainer": "_1Q_n7",
	"real-player-placeholder": "_3NHML",
	"realPlayerPlaceholder": "_3NHML",
	"players-list-slidable": "_2OSHo",
	"playersListSlidable": "_2OSHo",
	"single-item-cover": "RIVkR",
	"singleItemCover": "RIVkR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/mobile/views/home/home.styl
// module id = 2817
// module chunks = mobile/mobile